module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "button is-primary is-inverted is-outlined is-small",
    on: {
      "click": _vm.toggleDarkTheme
    }
  }, [_vm._v(_vm._s(_vm.buttonText))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-729e13e0","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ToggleDarkTheme.vue
// module id = 405
// module chunks = 1